import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import CloudinaryImage from "@/components/cloudinary-image";
import { cn } from "@/lib/utils";
import type { LocationSetType } from "@/pages/company/types";

interface LocationCardProps {
  className?: string;
  isClosed: boolean;
  location: LocationSetType;
}

export default function LocationCard({
  className,
  isClosed,
  location,
}: LocationCardProps) {
  const { locationUrl, name } = useMemo(
    () => ({
      locationUrl: `/location/${location.company.slug}/${location.slug}`,
      name: location.displayName || location.company.name,
    }),
    [location]
  );

  return (
    <div
      className={cn(
        "group relative flex w-4/10 shrink-0 flex-col gap-1 object-cover md:w-[calc(50%-7px)]",
        className
      )}
    >
      <CloudinaryImage
        className="mb-1 aspect-[4/3] max-h-25 rounded-[10px] shadow-white/25 transition-shadow group-hover:shadow-0-0-20 md:aspect-[3/2] md:max-h-none"
        location={location}
        rW={500}
      />
      <h3
        className={cn(
          "font-medium text-16",
          isClosed ? "text-pale-lavender" : "text-white"
        )}
      >
        <Link className="link-overlay" to={locationUrl}>
          {name} {isClosed && " - CLOSED"}
        </Link>
      </h3>
      <h4 className="font-normal text-14 text-pale-lavender">
        {[location.locality.locality, location.locality.region]
          .filter((val) => val?.length > 0)
          .join(", ")}
      </h4>
    </div>
  );
}
